export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";
// Sign-in is email link or password on the app's own /login page.
export const getLoginUrl = () => "/login";
